import CustomSection from '@src/quince-site-common/src/domains/CustomSection'

export const isFullBleedMediaSectionDataValid = (sectionDetails: CustomSection | undefined) => {
  if (!sectionDetails) {
    return false
  }

  const isValidVideoPresent = sectionDetails?.videos?.[0]?.url
  const isValidImagePresent = sectionDetails?.images?.[0]?.url
  return isValidVideoPresent || isValidImagePresent
}
